// "The big map exists" hooks. Kept in a module with no imports, so it is set up before any module that registers
// a hook, whatever order the (partly circular) imports load in.

const hooks: ((map: L.Map) => void)[] = [];
let readyMap: L.Map | null = null;

/** Runs `fn` once the big map exists (map tools add their layers this way). */
export function onMapReady(fn: (map: L.Map) => void): void {
  hooks.push(fn);
  if (readyMap) fn(readyMap);
}
/** Called by bigmap.ts when it has created the map. */
export function mapIsReady(map: L.Map): void {
  readyMap = map;
  for (const fn of hooks) fn(map);
}
